import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const updatemaxtimeblock = async (data) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.updatemaxtimeblock()}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (!res.ok) {
        return { error: true, message: 'Update max time block request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default updatemaxtimeblock;
